import { render, staticRenderFns } from "./5BankInformation.vue?vue&type=template&id=2756d98a"
import script from "./5BankInformation.vue?vue&type=script&lang=js"
export * from "./5BankInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports